import { render, staticRenderFns } from "./HyphenList.vue?vue&type=template&id=51a15324&scoped=true"
import script from "./HyphenList.vue?vue&type=script&setup=true&lang=js"
export * from "./HyphenList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HyphenList.vue?vue&type=style&index=0&id=51a15324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a15324",
  null
  
)

export default component.exports